import { render, staticRenderFns } from "./BoolDifferenceTopBarIcon.vue?vue&type=template&id=22c093d8&"
import script from "./BoolDifferenceTopBarIcon.vue?vue&type=script&lang=js&"
export * from "./BoolDifferenceTopBarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports